import React , {useEffect, useState} from "react"
import axios from "axios"
import { connect } from "react-redux";
import {
  Row,
  Col,
} from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings";
import RecentAdditions from "./recent-additions";
import MonthlyEarnings2 from "./montly-earnings2";
import Inbox from "./inbox";
import RecentActivity from "./recent-activity";
import WidgetUser from "./widget-user";
import YearlySales from "./yearly-sales";
import AdvancedFilter from "./advanced-filter"; // الـ component الجديد
import api, { FILE_BASE_URL } from '../../utils/api';

// الملفات الجديدة للجداول
import LatestJournalists from "./latest-journalists";
import LatestActivists from "./latest-activists";
import LatestInstitutions from "./latest-institutions";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

const Dashboard = (props) => {

  document.title = "";

  const breadcrumbItems = [
    { title: "", link: "#" },
    { title: "", link: "#" }
  ]

  const [counts, setCounts] = useState({
    institutions: 0,
    journalists: 0,
    activists: 0,
  });

  useEffect(() => {
    props.setBreadcrumbItems('' , breadcrumbItems)

   const fetchCounts = async () => {
     try {
       const [instRes, jourRes, actRes] = await Promise.all([
         api.get("/institutions"),
         api.get("/journalists"),
         api.get("/activists"),
       ]);

        setCounts({
          institutions: instRes.data.length || instRes.data.data?.length || 0,
          journalists: jourRes.data.length || jourRes.data.data?.length || 0,
          activists: actRes.data.length || actRes.data.data?.length || 0,
        });
      } catch (error) {
        console.error("فشل في جلب الإحصائيات:", error);
      }
    };

    fetchCounts();
  }, [])

  const reports = [
    { title: "المؤسسات", iconClass: "briefcase-outline", total: counts.institutions, average: "", badgecolor: "info", subtitle: "عدد المؤسسات ضمن قاعدة البيانات" },
    { title: "الصحفيين", iconClass: "microphone", total: counts.journalists, average: "", badgecolor: "info", subtitle: "عدد الصحفيين ضمن قاعدة البيانات" },
    { title: "الناشطين", iconClass: "target", total: counts.activists, average: "", badgecolor: "info", subtitle: "عدد الناشطين ضمن قاعدة البيانات" },
    { title: "الإجمالي", iconClass: "account-group", total: counts.institutions + counts.journalists + counts.activists, average: "", badgecolor: "info", subtitle: "المجموع الكلي لكافة السجلات" }
  ]

  return (
    <React.Fragment>
{/* Advanced Filter */}
      <Row>
        <Col xl="12">
          <AdvancedFilter />
        </Col>
      </Row>
      {/*mimi widgets */}
      <Miniwidget reports={reports} />

      

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings />
        </Col>

        <Col xl="9">
          {/* Recent Additions */}
          <RecentAdditions />
        </Col>
      </Row>
      
      <Row>
        <Col xl="4">
          {/* Latest Journalists */}
          <LatestJournalists />
        </Col>

        <Col xl="4">
          {/* Latest Activists */}
          <LatestActivists />
        </Col>

        <Col xl="4">
          {/* Latest Institutions */}
          <LatestInstitutions />
        </Col>
      </Row>

      

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);